var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFileOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.53942 28.5C6.91511 28.5 6.36616 28.2708 5.89255 27.8125C5.41893 27.3542 5.18213 26.8229 5.18213 26.2188V4.78125C5.18213 4.17708 5.41893 3.64583 5.89255 3.1875C6.36616 2.72917 6.91511 2.5 7.53942 2.5H18.4217L26.8175 10.6562V18.7188H24.4603V12.0938H16.904V4.78125H7.53942V26.2188H20.6498V28.5H7.53942ZM28.8519 28.3125L24.9446 24.5V28.1875H22.5873V20.5938H30.4019V22.875H26.5915L30.4988 26.6875L28.8519 28.3125ZM7.53942 26.2188V4.78125V26.2188Z",
    fill: "#1C4C96"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileOpen);
export default __webpack_public_path__ + "static/media/file_open.875f60ba5c033f3d797bcb47736c9388.svg";
export { ForwardRef as ReactComponent };